import { combineReducers } from "redux";
/* Reducers */
import appReducer from "./appReducer";
import userDataReducer from "./userDataReducer";

export default combineReducers({
  appStore: appReducer,
  userDataStore: userDataReducer,
});
